<div class="padding">
	<div class="flex center between margin-bottom-small">
		<b class="primary-dark">Upload files</b>
		<span class="grey">{{ instanceDetails?.instanceId }}</span>
	</div>
	@if (instanceDetails) {
		<div class="flex center bg-light-blue padding">
			<div class="flex-0 flex center">
				<b class="margin-right-smallest">Status:</b>

				@if (instanceDetails.runtimeStatus == 'Completed') {
					<span class="radius bg-primary white padding-right-smallest padding-left-smallest">{{ instanceDetails.runtimeStatus }}</span>
				} @else if (instanceDetails.runtimeStatus == 'Failed') {
					<span class="radius bg-red white padding-right-smallest padding-left-smallest">{{ instanceDetails.runtimeStatus }}</span>
				} @else if (instanceDetails.runtimeStatus == 'Terminated') {
					<span class="radius bg-red white padding-right-smallest padding-left-smallest">{{ instanceDetails.runtimeStatus }}</span>
				} @else if (instanceDetails.runtimeStatus == 'Canceled') {
					<span class="radius bg-orange padding-right-smallest padding-left-smallest">{{ instanceDetails.runtimeStatus }}</span>
				} @else if (instanceDetails.runtimeStatus == 'Suspended') {
					<span class="radius bg-orange padding-right-smallest padding-left-smallest">{{ instanceDetails.runtimeStatus }}</span>
				} @else if (instanceDetails.runtimeStatus == 'Running') {
					<span class="radius bg-orange padding-right-smallest padding-left-smallest">{{ instanceDetails.runtimeStatus }}</span>
				} @else if (instanceDetails.runtimeStatus == 'Pending') {
					<span class="radius bg-orange padding-right-smallest padding-left-smallest">{{ instanceDetails.runtimeStatus }}</span>
				} @else {
					<span class="radius bg-grey white padding-right-smallest padding-left-smallest">{{ instanceDetails.runtimeStatus }}</span>
				}
			</div>

			@if (instanceDetails.runtimeStatus == 'Pending' || instanceDetails.runtimeStatus == 'Running') {
				<div class="flex-1 progress-bar margin-left">
					<div class="progress-bar-value"></div>
				</div>
			}
		</div>
	}

	<div class="fix-height padding bg-light-grey flex column start">
		@if (instanceDetails) {
			<div class="flex center">
				<b class="margin-right-smallest">Created Time:</b>
				{{ instanceDetails.createdTime | date: 'dd/MM/yyyy HH:mm:ss' }}
			</div>
			<div class="flex center">
				<b class="margin-right-smallest">Last Updated Time:</b>
				{{ instanceDetails.lastUpdatedTime | date: 'dd/MM/yyyy HH:mm:ss' }}
			</div>

			<div class="flex column start">
				<b>Latest activity:</b>
				<span class="grey">{{ instanceDetails.customStatus.latestActivity }}</span>
			</div>

			<div class="flex full-width margin-top border-top padding-top">
				<div class="flex column flex-1 margin-right-small">
					<b>
						Uploaded Files
						<span class="bg-green white padding-right-smallest padding-left-smallest radius">{{ instanceDetails.customStatus.uploadedFiles.length }}</span>
						:
					</b>

					<div class="scrollable flex center column start">
						<div class="flex column gap margin-top-smallest">
							@for (item of instanceDetails.customStatus.uploadedFiles; track $index) {
								<div class="flex">
									<div class="square bg-primary" [style.backgroundImage]="'url(' + item.filePath + ')'"></div>
									<div class="flex column start margin-left-smallest">
										<span class="unicode small">{{ item.fileName }}</span>
										<span class="bg-green white padding-right-smallest padding-left-smallest radius">Uploaded</span>
									</div>
								</div>
							} @empty {
								No uploaded files
							}
						</div>
					</div>
				</div>

				<div class="flex column flex-1 margin-left-small">
					<b>
						Errors
						<span class="bg-orange padding-right-smallest padding-left-smallest radius">{{ instanceDetails.customStatus.invalidFiles.length }}</span>
						:
					</b>

					<div class="scrollable flex center column start">
						<div class="flex column gap margin-top-smallest">
							@for (item of instanceDetails.customStatus.invalidFiles; track $index) {
								<div class="flex">
									<div class="square bg-primary" [style.backgroundImage]="'url(' + item.filePath + ')'"></div>
									<div class="flex column start margin-left-smallest">
										<span class="unicode small">{{ item.fileName }}</span>
										<span class="bg-orange padding-right-smallest padding-left-smallest radius">{{ item.error }}</span>
									</div>
								</div>
							} @empty {
								No errors
							}
							@for (item of instanceDetails.customStatus.errorUploads; track $index) {
								<div class="flex">
									<div class="square bg-primary" [style.backgroundImage]="'url(' + item.filePath + ')'"></div>
									<div class="flex column start margin-left-smallest">
										<span class="unicode small">{{ item.fileName }}</span>
										<span class="bg-orange padding-right-smallest padding-left-smallest radius">{{ item.error }}</span>
									</div>
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		} @else {
			<div class="flex center">
				<i class="fa-solid fa-spinner fa-spin margin-right-smallest"></i>
				Starting file validation...
			</div>
		}
	</div>

	<div class="flex column end margin-top-small">
		<div class="flex center">
			<button (click)="close()">
				<i class="fa-solid fa-xmark"></i>
				Close
			</button>
		</div>
	</div>
</div>
